/**
 * Created by ren on 17/07/2017.
 */
import keyBy from 'lodash/keyBy';
import { takeEvery, select, call, put, takeLatest } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { change, arrayRemove } from 'redux-form';

import * as sagaCommon from '../../sagasCommon';
import * as apiCommon from '../../../services/apiCommon';
import * as apiAdmin from '../../../services/apiAdmin';
import * as apiInventoryTransfer from '../../../services/inventory/transfer/api_inventory_transfer';
import * as utilityPreference from '../../../services/preference/utilty_preference';
import * as helperInventory from '../../../services/inventory/helper_inventory';
import * as commonInventory from '../../../services/inventory/common_inventory';

import {
  getDefaultTransactionStatus,
  getFormLines,
  getDefaultLineStatus,
  getFromLocationId
} from '../../../components/admin/inventory_management/transfer/InventoryTransferSelector';
import {
  GET_INVENTORY_TRANSFER,
  SAVE_INVENTORY_TRANSFER,
  FETCH_LIST_INVENTORY_TRANSFER,
  INITIALIZE_MASS_INVENTORY_TRANSFER,
  GET_INVENTORY_TRANSFER_LINE_ITEM_LOCATION,
  GET_PREFERENCES_BY_FROM_LOCATION,
  GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION,
  SELECT_LINES_BY_STATUS,
  SET_LINES_RECEIVED_QUANTITY
} from '../../../constants/constant_saga_types';
import {
  MASS_TRANSFER_IN_PROGRESS,
  MASS_TRANSFER_DONE,
  SET_INVENTORY_TRANSFER_PREFERENCES,
  SET_INVENTORY_STATUS_LIST,
  SET_TRANSACTION_STATUS_LIST
} from '../../../constants/constant_action_types';
import {
  CLOSED,
  OPEN,
} from '../../../constants/constant_transaction_status';
import { SERIALIZED } from '../../../constants/constant_item_types';
import { InventoryTransferForm as form } from '../../../constants/constant_form_names';

function* callSaveInventoryTransfer(feathersApp, action) {
  try {
    yield sagaCommon.showProgressSaveRecord();
    const { user } = yield select();
    const { data, redirectToView } = action;

    yield sagaCommon.showProgressSaveRecord();

    const result = yield call(apiInventoryTransfer.saveInventoryTransfer, feathersApp, {
      user,
      data
    });
    const id = result && result.id;

    if (id) {
      yield callGetInventoryTransfer(feathersApp, { id });
    }

    if (redirectToView) {
      browserHistory.push(`/admin/inventory/transfer/view/${id}`);
    } else {
      browserHistory.push(`/admin/inventory/transfer/edit/${id}`);
    }

    yield sagaCommon.doneSaveRecord(null, 'Inventory transfer was saved');
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* saveInventoryTransferSaga(feathersApp) {
  yield takeEvery(SAVE_INVENTORY_TRANSFER, callSaveInventoryTransfer, feathersApp);
}

function* callFetchListInventoryTransfer(feathersApp, action) {
  try {
    const { silent, filters } = action;
    yield sagaCommon.showProgressListTable(silent);
    const dataParams = {
      filters,
      list_type: 'inventory_transfer'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(sagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (e) {
    yield sagaCommon.showErrorListTable(e);
  }
}

export function* fetchInventoryStatusList(feathersApp, action) {
  const { fields, included_status } = action;
  const inventoryStatusList = yield call(apiAdmin.fetchInventoryStatusDropdown, feathersApp, {
    fields,
    searchParams: { included_status }
  });
  yield put({ type: SET_INVENTORY_STATUS_LIST, inventoryStatusList });
}

export function* fetchTransactionStatusList(feathersApp, action) {
  const { fields, included_status } = action;
  const transactionStatusList = yield call(apiAdmin.fetchTransactionStatusDropdown, feathersApp, {
    fields,
    searchParams: { included_status }
  });
  yield put({ type: SET_TRANSACTION_STATUS_LIST, transactionStatusList });
}

export function* fetchListInventoryTransferSaga(feathersApp) {
  yield takeLatest(FETCH_LIST_INVENTORY_TRANSFER, callFetchListInventoryTransfer, feathersApp);
}

export function* getInventoryTransferSaga(feathersApp) {
  yield takeEvery(GET_INVENTORY_TRANSFER, callGetInventoryTransfer, feathersApp);
}

function* callGetInventoryTransfer(feathersApp, action) {
  try {
    const { user, tenant, intl } = yield select();
    const { id } = action;

    yield sagaCommon.showProgressDataById();

    let params = {
      settings: [
        'use_status_pick',
        'use_status_pack',
        'use_status_ship',
        'include_backorder',
        'auto_receipt',
        'auto_receipt_hours'
      ],
      accountId: (tenant || {}).id,
      intl
    };

    if (id) {
      const data = yield call(apiInventoryTransfer.fetchInventoryTransferById, feathersApp, {
        id,
        user
      });
      const locationId = data.from_location_id;

      params.subsidiaryId = data.from_subsidiary_id;
      params.locationId = data.from_location.parent_id ? data.from_location.parent_id : locationId;

      let preferences = {};

      if (data.status.cid !== CLOSED) {
        preferences = yield call(utilityPreference.getPreferenceValues, feathersApp, params);
      }

      yield put({ type: SET_INVENTORY_TRANSFER_PREFERENCES, settings: preferences });
      yield sagaCommon.doneDataById(data);

      if (data.status.cid === OPEN) {
        const skipUpdateQuantity = true;
        yield put({
          type: GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION,
          locationId,
          skipUpdateQuantity
        });
      }
    } else {
      const preferences = yield call(utilityPreference.getPreferenceValues, feathersApp, params);
      yield put({ type: SET_INVENTORY_TRANSFER_PREFERENCES, settings: preferences });

      const defaultTransactionStatus = yield select(getDefaultTransactionStatus);

      yield sagaCommon.doneDataById({
        is_intercompany_transfer: false,
        status_id: defaultTransactionStatus.id,
        status: defaultTransactionStatus
      });
    }
  } catch (e) {
    yield sagaCommon.showErrorDataById(e, true);
  }
}

export function* initializeMassInventoryTransferSaga(feathersApp) {
  yield takeEvery(
    INITIALIZE_MASS_INVENTORY_TRANSFER,
    callInitializeMassInventoryTransfer,
    feathersApp
  );
}

// function buildInventoryTransferLine(itemLocation, settings, defaultLineStatus) {
//   const qtyAvailable = helperInventory.calculateQuantityAvailable(itemLocation, settings);
//   const qtyTransferMax = itemLocation.item_type === SERIALIZED ? 1 : qtyAvailable;
//   const line = {
//     line_id: uuid(),
//     quantity_transfer: qtyTransferMax,
//     quantity_available: qtyAvailable,
//     quantity_receive: 0,
//     from_location_type_id: itemLocation.location_type,
//     item: itemLocation.item,
//     item_id: itemLocation.item_id,
//     item_type_id: itemLocation.item_type,
//     from_currency_id: itemLocation.currency_id,
//     from_location_id: itemLocation.location_id,
//     from_subsidiary_id: itemLocation.subsidiary_id,
//     status_id: defaultLineStatus.id,
//     status: defaultLineStatus,
//     onEditMode: false
//   };

//   return line;
// }

function* callInitializeMassInventoryTransfer(feathersApp, action) {
  try {
    const { from_location_id, from_subsidiary_id } = action;

    if (!from_location_id) return;

    yield put(change(form, 'isFetchingItemLocations', true));
    yield put({ type: MASS_TRANSFER_IN_PROGRESS });

    const lines = yield call(apiInventoryTransfer.getItemLocation, feathersApp, from_location_id, from_subsidiary_id);
    const defaultLineStatus = yield select(getDefaultLineStatus);

    const newLines = lines.map(line => ({
      ...line,
      status: defaultLineStatus,
      status_id: defaultLineStatus.id,
      onEditMode: false
    }));

    yield put(change(form, 'lines', newLines));
    yield put({ type: MASS_TRANSFER_DONE });
    yield put(change(form, 'isFetchingItemLocations', false));
  } catch (e) {
    console.error(e.stack);
  }
}

export function* getInventoryTransferLineItemLocationSaga(feathersApp) {
  yield takeEvery(
    GET_INVENTORY_TRANSFER_LINE_ITEM_LOCATION,
    callGetInventoryTransferLineItemLocationSaga,
    feathersApp
  );
}

function* callGetInventoryTransferLineItemLocationSaga(feathersApp, action) {
  try {
    const { user } = yield select();
    const { locationId, itemId, index, itemUom } = action;
    yield put(change(form, `lines[${index}].isFetchingItemLocation`, true));
    const itemLocation = yield call(apiInventoryTransfer.getItemLocationById, feathersApp, {
      itemId: itemId.split(':')[0],
      locationId,
      user
    });

    if (itemLocation) {
      const { preference } = yield select();
      const { settings } = preference;
      const qtyAvailable = helperInventory.calculateQuantityAvailable(itemLocation, settings);
      const { item_type_id, item_type } = itemLocation;
      const qtyTransferMax = (item_type_id || item_type) === SERIALIZED ? 1 : qtyAvailable;

      if (itemUom) {
        yield put(change(form, `lines[${index}].uom_quantity_available`, Math.floor(qtyAvailable/itemUom.conversion_rate)));
        yield put(change(form, `lines[${index}].uom_quantity_transfer`, Math.floor(qtyTransferMax/itemUom.conversion_rate)));
      }

      yield put(change(form, `lines[${index}].quantity_available`, qtyAvailable));
      yield put(change(form, `lines[${index}].quantity_transfer`, qtyTransferMax));
      yield put(change(form, `lines[${index}].isFetchingItemLocation`, false));
    } else {
      yield call(resetLine, index);
      throw new Error('Item is not available in location');
    }
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

function* resetLine(index) {
  yield put(arrayRemove(form, 'lines', index));
}

export function* getAllInventoryTransferLinesItemLocationSaga(feathersApp) {
  yield takeLatest(
    GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION,
    callGetAllInventoryTransferLinesItemLocationSaga,
    feathersApp
  );
}

function* callGetAllInventoryTransferLinesItemLocationSaga(feathersApp, action) {
  try {
    const lines = yield select(getFormLines);
    const fromLocationId = yield select(getFromLocationId);
    const { locationId, skipUpdateQuantity } = action;

    const itemIds = lines.map(line => line.item_id.split(':')[0]);
    const itemLocations = yield call(commonInventory.getItemLocations, feathersApp, {
      locationId,
      itemIds
    });
    const indexedItemLocations = keyBy(
      itemLocations,
      itemLocation => `${itemLocation.item_id}:${itemLocation.location_id}`
    );

    let validItemLocations = true;

    const { preference } = yield select();
    const { settings } = preference;
    const newLines = [];

    lines.forEach(line => {
      const index = `${line.item_id.split(':')[0]}:${fromLocationId}`;
      const newLine = { ...line };
      const itemLocation = indexedItemLocations[index];

      if (itemLocation) {
        const qtyAvailable = helperInventory.calculateQuantityAvailable(itemLocation, settings);
        const qtyTransferMax = itemLocation.item_type === SERIALIZED ? 1 : qtyAvailable;

        if (newLine.quantity_available !== qtyAvailable) {
          newLine.quantity_available = qtyAvailable;
        }

        if (!skipUpdateQuantity && newLine.quantity_transfer !== qtyTransferMax) {
          newLine.quantity_transfer = qtyTransferMax;
        }

        newLines.push(newLine);
      } else {
        validItemLocations = false;
      }
    });

    yield put(change(form, 'lines', newLines));

    if (!validItemLocations) throw new Error('Item is not available in location');
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* getPreferencesByFromLocationSaga(feathersApp) {
  yield takeEvery(GET_PREFERENCES_BY_FROM_LOCATION, callGetPreferencesByFromLocation, feathersApp);
}

function* callGetPreferencesByFromLocation(feathersApp, action) {
  try {
    const { tenant, intl } = yield select();
    const { subsidiaryId, locationId } = action;
    const params = {
      subsidiaryId,
      locationId,
      accountId: (tenant || {}).id,
      settings: [
        'use_status_pick',
        'use_status_pack',
        'use_status_ship',
        'include_backorder',
        'auto_receipt',
        'auto_receipt_hours',
        'enable_item_part_quantity',
      ],
      intl
    };

    const preferences = yield call(utilityPreference.getPreferenceValues, feathersApp, params);
    yield put({ type: SET_INVENTORY_TRANSFER_PREFERENCES, settings: preferences });
  } catch (e) {
    console.error(e);
  }
}

export function* selectLinesByStatusSaga(feathersApp) {
  yield takeEvery(SELECT_LINES_BY_STATUS, callSelectLinesByStatus, feathersApp);
}

function* callSelectLinesByStatus(feathersApp, action) {
  try {
    const { inventoryStatusId } = action;
    const lines = yield select(getFormLines);
    const updatedLines = lines.map(line => {
      const statusId = line.status.cid;

      line.process_line = statusId === inventoryStatusId;

      return line;
    });

    yield put(change(form, 'lines', updatedLines));
  } catch (e) {
    console.error(e);
  }
}

export function* setLinesReceivedQuantitySaga(feathersApp) {
  yield takeEvery(SET_LINES_RECEIVED_QUANTITY, callSetLinesReceivedQuantity, feathersApp);
}

function* callSetLinesReceivedQuantity(feathersApp, action) {
  try {
    const lines = yield select(getFormLines);
    const updatedLines = lines.map(line => {
      if (line.process_line) {
        line.process_line = true;
        line.quantity_receive = line.quantity_transfer;
      }
      return line;
    });
    yield put(change(form, 'lines', updatedLines));
  } catch (e) {
    console.error(e);
  }
}
